/**
 * Created by claudenbach on 1/23/2017.
 */

import { LMEditorService } from './lm-editor.service';
import { LMActionService } from '@services/lm-action.service';
import { LMFormatterService } from '@list/formatters';

export const isEditable = (
  lmFormatterService: LMFormatterService,
  lmEditorService: LMEditorService,
  lmActionService: LMActionService,
  columnDef: ListGridColumn,
  dataView: LMListDataView
): boolean  => {

  // Handle a field that is conditionally editable. Use the method columnRequiresEditor()
  // to handle a field that is unconditionally non-editable.
  if (!dataView || dataView?.isTreeMoreLink) {
    return false;
  }

  if (dataView.rowStatus && dataView.rowStatus.icon === 'new' || dataView.isNewRow) {
    return true;
  }

  if (columnDef.displayField.isSymbolicKey) {
    return false;
  }

  if (lmEditorService.listSpec.busListSpec.implementsCubeView) {
    // Cash forecast period cubes is an overloaded example of cells that are editable if it is a factorw.
    // And if not a fact row, it has a cube drill. Render editor if fact row.
    return(columnDef.displayField.allowUpdate && dataView.cubeInfo.isFactRowElement);
  }

  if (!columnDef.displayField.allowUpdate) {
    return false;
  }

  // if listSpec has 'disable select in webui' and list field has 'allow update' return false
  if (lmEditorService.listSpec.busListSpec.selection === 'disabled') {
    return false;
  }

  if (lmFormatterService.isTotalRow(dataView)) {
    return false;
  }

  if (columnDef.displayField.visibility) {
    if (!lmFormatterService.isConditionValid(columnDef.displayField.visibility, dataView)) {
      return false;
    }
  }

  const actions = lmEditorService.listSpec.busClassSpec.actions;
  let actionSpec = null;

  if (lmEditorService.listSpec.isTemplateList) {
    const targetDataView = dataView.dataView;

    if (!targetDataView.isAlreadyDefined) {
      const createActions = lmActionService.getCreateActions(actions, targetDataView.actionIndexes);
      actionSpec = (createActions.length > 0) ? createActions[ 0 ] : null;
    } else {
      actionSpec = lmActionService.getDefaultUpdateAction(actions, targetDataView.actionIndexes, true, true);
    }
  } else {
    actionSpec = lmActionService.getDefaultUpdateAction(actions, dataView.actionIndexes, true, true);
  }

  return (actionSpec) ? true : false;
};
